import http from '../../HttpConfig'
import { APIS_ENDPOINTS } from '../../SERVICE-CONSTANTS'

const letter_endpoints = APIS_ENDPOINTS.letter

export interface IPlansMessagePayload {
  UserId: number
  Files: File[]
  Description?: string;
  Title?: string
  IsSendToPersonel?: boolean
  ReceiverRole?: string
  documentNumber: string,
  type: string,
  documentDate: string,
  PersonelId?: number[]      
  IsSendToTranscript?: boolean 
}
export const request_sendbyadmin = async ({
  Files,
  UserId,
  Description,
  Title,
  IsSendToPersonel,
  ReceiverRole,
  PersonelId,        
  IsSendToTranscript,  
  documentNumber,
  type,
  documentDate,
}: IPlansMessagePayload) => {
  const formData = new FormData()

  if (documentNumber) {
    formData.append("DocumentNumber", documentNumber || "");
  }
  if (type) {
    formData.append("Type", type || "");
  }
  if (documentDate) {
    formData.append("DocumentDate", documentDate || "");
  }

  if (Files && Files.length !== 0) {
    for (var i = 0; i < Files.length; i++) {
      formData.append('Files', Files[i])
    }
  }

  formData.append('UserId', UserId?.toString())
  formData.append('IsSendToPersonel', IsSendToPersonel?.toString() || '')

  if (ReceiverRole) {
    formData.append('ReceiverRole', ReceiverRole?.toString() || '')
  }

  if (PersonelId && PersonelId.length !== 0) {
    PersonelId.forEach((id) => {
      formData.append('PersonelId', id?.toString())
    })
  }

  formData.append('IsSendToTranscript', IsSendToTranscript?.toString() || 'false')

  if (Description) {
    formData.append('Description', Description)
  }

  if (Title) {
    formData.append('Title', Title)
  }

  return http.post(letter_endpoints.sendbyadmin, formData)
}



export const request_getrequestcountbyadminrole = async () => {
  return http.get(letter_endpoints.getrequestcountbyadminrole)
}


export const request_getAll = async ({
  search,
  CurrentPage,
  PageSize,
  IsMe,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  IsMe: boolean
}) => {
  return http.get(
    letter_endpoints.datatable +
    `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}${IsMe !== undefined ? `&IsMe=${IsMe}` : ''
    }`
  )
}

export const request_getAllLetterByPersonel = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    letter_endpoints.getall +
    `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}

export const request_detail = async (id: number) => {
  return http.get(letter_endpoints.detail + `?id=${id}`)
}

export const request_changeletter = async ({ id, letterType }: { id: number, letterType: number }) => {
  return http.post(letter_endpoints.changeletter + `?id=${id}&letterType=${letterType}`)
}


export const request_getAllByUser = async ({
  search,
  CurrentPage,
  PageSize,
  UserId,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  UserId: boolean
}) => {
  return http.get(
    letter_endpoints.datatablebyuserid +
    `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}${UserId !== undefined ? `&UserId=${UserId}` : ''
    }`
  )
}

export const request_acceptletter = async (id: number) => {
  return http.post(letter_endpoints.acceptletter + `?id=${id}`)
}

export const request_getallletternote = async (LetterId: number) => {
  return http.get(letter_endpoints.getallletternote + `?LetterId=${LetterId}`)
}

export const request_addreference = async ({ letterId, receiverId, receiverRole, title, text, file }) => {
  const formData = new FormData();

  formData.append("LetterId", letterId.toString() || "");
  formData.append("Title", title || "");
  formData.append("Text", text || "");
  formData.append("IFile", file || "");
  formData.append("ReceiverRole", receiverRole || "");
  formData.append("ReceiverId", receiverId || "");
  return http.post(letter_endpoints.addreference, formData)
}

export const request_sendreferencetouser = async (values) => {
  const formData = new FormData();
  formData.append("LetterId", values.letterId.toString() || "");
  formData.append("Title", values.title || "");
  formData.append("Text", values.text || "");
  formData.append("IFile", values.IFile || "");
  return http.post(letter_endpoints.sendreferencetouser, formData)
}

export const request_addnote = async ({ letterId, title, text, isSendToUser, file }) => {
  const formData = new FormData();
  formData.append("LetterId", letterId.toString() || "");
  formData.append("Title", title || "");
  formData.append("Text", text || "");
  formData.append("IFile", file || "");
  formData.append("IsSendToUser", isSendToUser || "");
  return http.post(letter_endpoints.addnote, formData)
}

export const request_archiveletter = async (id: number) => {
  return http.post(letter_endpoints.archiveletter + `?id=${id}`)
}

export const request_accepttoletter = async ({
  letterId,
  isAccept,
  text,
  iFile,
}: {
  letterId: number,
  isAccept: boolean,
  text: string,
  iFile: File,
}) => {
  const formData = new FormData();
  formData.append("LetterId", letterId?.toString() || "");
  formData.append("IsAccept", isAccept?.toString() || "");
  formData.append("Text", text || "");
  formData.append("IFile", iFile || "");

  return http.post(letter_endpoints.acceptToLetter, formData)
}

export const request_revokeReferral = async ({
  letterId,
  title,
  text,
  iFile,
}: {
  letterId: number,
  title: string,
  text: string,
  iFile: File,
}) => {
  const formData = new FormData();
  formData.append("LetterId", letterId?.toString() || "");
  formData.append("Title", title || "");
  formData.append("Text", text || "");
  formData.append("IFile", iFile || "");

  return http.post(letter_endpoints.revokeReferral, formData)
}

export const request_upsertDocumentToLetter = async ({
  letterId,
  documentNumber,
  type,
  documentDate,
}: {
  letterId: number,
  documentNumber: string,
  type: string,
  documentDate: string,
}) => {
  const formData = new FormData();
  formData.append("LetterId", letterId?.toString() || "");
  formData.append("DocumentNumber", documentNumber || "");
  formData.append("Type", type || "");
  formData.append("DocumentDate", documentDate || "");

  return http.post(letter_endpoints.upsertDocumentToLetter, formData)
}